import { config } from 'app/config'
import { createBrowserHistory } from 'history'

export const history = createBrowserHistory({ basename: config.APP_BASE_URL })
